const CURRENT_USER_ROLE_ID = 'CURRENT_USER_ROLE_ID';
const CURRENT_USER_ROLES = 'CURRENT_USER_ROLES';
const CURRENT_USER_ORDERS_COUNT = 'CURRENT_USER_ORDERS_COUNT';
const CURRENT_USER_UID = 'CURRENT_USER_UID';
const CURRENT_USER = 'CURRENT_USER';
const CURRENT_USER_DETAILS = 'CURRENT_USER_DETAILS';
const CURRENT_USER_PHONE_NUMBERS = 'CURRENT_USER_PHONE_NUMBERS';
const CURRENT_USER_ALLOWED_PHONE_NUMBERS = 'CURRENT_USER_ALLOWED_PHONE_NUMBERS';
const CURRENT_USER_SHIFT = 'CURRENT_USER_SHIFT';
const ALL_WORKING_SHIFTS = 'ALL_WORKING_SHIFTS';
const SHIFTS_TO_ACTIVATE = 'SHIFTS_TO_ACTIVATE';
const ALLOWED_SHIFTS = 'ALLOWED_SHIFTS';
const ACTIVE_WORK_GROUPS = 'ACTIVE_WORK_GROUPS';
const ACTIVE_WORK_GROUP = 'ACTIVE_WORK_GROUP';
const UPDATE_WORKING_SHIFT = 'UPDATE_WORKING_SHIFT';
const UPDATE_USER_SETTINGS = 'UPDATE_USER_SETTINGS';
const USER_FREE_DAY = 'USER_FREE_DAY';

const state = {
  details: null,
  currentUserRoleId: null,
  currentUserRoles: null,
  ordersCountDetails: null,
  myShift: null,
  shifts: null,
  currentUID: null,
  currentUser: null,
  phoneNumbers: null,
  allowedPhoneNumbers: null,
  shiftsToActivate: null,
  allowedShifts: null,
  activeWorkGroups: null,
  activeWorkGroup: null,
  updateActiveWorkingShift: false,
  userSettings: {},
  isFreeToday: false,
};

const getters = {
  currentUserRoleId: state => state.currentUserRoleId,
  currentUserRoles: state => state.currentUserRoles,
  ordersCountDetails: state => state.ordersCountDetails,
  shifts: state => state.shifts,
  myShift: state => state.myShift,
  currentUID: state => state.currentUID,
  currentUser: state => state.currentUser,
  phoneNumbers: state => state.phoneNumbers,
  allowedPhoneNumbers: state => state.allowedPhoneNumbers,
  details: state => state.details,
  shiftsToActivate: state => state.shiftsToActivate,
  allowedShifts: state => state.allowedShifts,
  updateActiveWorkingShift: state => state.updateActiveWorkingShift,
  userSettings: state => state.userSettings,
  activeWorkGroups: state => state.activeWorkGroups,
  activeWorkGroup: state => state.activeWorkGroup,
  isFreeToday: state => state.isFreeToday,
};

const actions = {
  setDetails({dispatch, commit}, payload) {
    commit(CURRENT_USER_DETAILS, payload);
  },
  setCurrentUserRoles({dispatch, commit}, payload) {
    commit(CURRENT_USER_ROLES, payload);
  },
  setCurrentUserRoleId({dispatch, commit}, payload) {
    commit(CURRENT_USER_ROLE_ID, payload);
  },
  setOrdersCountDetails({dispatch, commit}, payload) {
    commit(CURRENT_USER_ORDERS_COUNT, payload);
  },
  setCurrentUID({dispatch, commit}, payload) {
    commit(CURRENT_USER_UID, payload);
  },
  setCurrentUser({dispatch, commit}, payload) {
    commit(CURRENT_USER, payload);
  },
  setPhoneNumbers({dispatch, commit}, payload) {
    commit(CURRENT_USER_PHONE_NUMBERS, payload);
  },
  setAllowedPhoneNumbers({dispatch, commit}, payload) {
    commit(CURRENT_USER_ALLOWED_PHONE_NUMBERS, payload);
  },
  setMyShift({dispatch, commit}, payload) {
    commit(CURRENT_USER_SHIFT, payload);
  },
  setShifts({dispatch, commit}, payload) {
    commit(ALL_WORKING_SHIFTS, payload);
  },
  setShiftsToActivate({dispatch, commit}, payload) {
    commit(SHIFTS_TO_ACTIVATE, payload);
  },
  setAllowedShifts({dispatch, commit}, payload) {
    commit(ALLOWED_SHIFTS, payload);
  },
  setActiveWorkGroups({dispatch, commit}, payload) {
    commit(ACTIVE_WORK_GROUPS, payload);
  },
  setActiveWorkGroup({dispatch, commit}, payload) {
    commit(ACTIVE_WORK_GROUP, payload);
  },
  setUserIsFreeToday({dispatch, commit}, payload) {
    commit(USER_FREE_DAY, payload);
  },
  setUpdateActiveWorkingShift({dispatch, commit}, payload) {
    commit(UPDATE_WORKING_SHIFT, payload);
  },
  setUserSettings({dispatch, commit}, payload) {
    commit(UPDATE_USER_SETTINGS, payload);
  },
};

const mutations = {
  [CURRENT_USER_ROLE_ID](state, payload) {
    state.currentUserRoleId = payload;
  },
  [CURRENT_USER_DETAILS](state, payload) {
    state.details = payload;
  },
  [CURRENT_USER_ROLES](state, payload) {
    state.currentUserRoles = payload;
  },
  [CURRENT_USER_ORDERS_COUNT](state, payload) {
    state.ordersCountDetails = payload;
  },
  [CURRENT_USER_UID](state, payload) {
    state.currentUID = payload;
  },
  [CURRENT_USER](state, payload) {
    state.currentUser = payload;
  },
  [CURRENT_USER_PHONE_NUMBERS](state, payload) {
    state.phoneNumbers = payload;
  },
  [CURRENT_USER_ALLOWED_PHONE_NUMBERS](state, payload) {
    state.allowedPhoneNumbers = payload;
  },
  [CURRENT_USER_SHIFT](state, payload) {
    state.myShift = payload;
  },
  [ALL_WORKING_SHIFTS](state, payload) {
    state.shifts = payload;
  },
  [SHIFTS_TO_ACTIVATE](state, payload) {
    state.shiftsToActivate = payload;
  },
  [ALLOWED_SHIFTS](state, payload) {
    state.allowedShifts = payload;
  },
  [ACTIVE_WORK_GROUPS](state, payload) {
    state.activeWorkGroups = payload;
  },
  [ACTIVE_WORK_GROUP](state, payload) {
    state.activeWorkGroup = payload;
  },
  [UPDATE_WORKING_SHIFT](state, payload) {
    state.updateActiveWorkingShift = payload;
  },
  [UPDATE_USER_SETTINGS](state, payload) {
    state.userSettings = payload;
  },
  [USER_FREE_DAY](state, payload) {
    state.isFreeToday = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
